"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGeometry = void 0;

var _ = require(".");

var createGeometry = function (data) {
  var type = data.type;
  var coords = data.coordinates;
  var geometry;

  switch (type) {
    case 'Point':
      geometry = new _.Point(coords);
      break;

    case 'MultiPoint':
      geometry = new _.MultiPoint(coords);
      break;

    case 'LineString':
      geometry = new _.LineString(coords);
      break;

    case 'MultiLineString':
      geometry = new _.MultiLineString(coords);
      break;

    case 'Polygon':
      geometry = new _.Polygon(coords);
      break;

    case 'MultiPolygon':
      geometry = new _.MultiPolygon(coords);
      break;

    default:
      geometry = null;
  }

  return geometry;
};

exports.createGeometry = createGeometry;